import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20action%20collage%20with%20athletes%20in%20motion%20basketball%20soccer%20swimming%20running%2C%20warm%20orange%20and%20amber%20lighting%2C%20abstract%20geometric%20shapes%2C%20modern%20sporty%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20sports%20photography%20style%2C%20dark%20background%20with%20warm%20highlights&width=1800&height=1200&seq=yunkai-hero-bg&orientation=landscape"
        alt="云开体育 - 专业体育运动解决方案平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-6">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">专业体育运动解决方案平台</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-6 leading-tight tracking-wide">
          让运动改变生活
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          云开体育 — 专注体育运动领域的综合服务平台，提供体育培训、赛事组织、运动装备及场馆管理等一站式解决方案。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/categories"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            了解服务
          </Link>
          <Link
            to="/about#contact"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-background-50 font-semibold rounded-lg border border-white/25 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            联系我们
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          {[
            { num: '200+', label: '承办赛事' },
            { num: '50+', label: '专业教练' },
            { num: '10万+', label: '服务用户' },
            { num: '100+', label: '合作场馆' },
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-xl md:text-2xl font-bold font-heading text-background-50">{stat.num}</div>
              <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}